// @design.estate scope
import * as deesElement from '@design.estate/dees-element';
import * as deesCatalog from '@design.estate/dees-catalog';

// @serve.zone scope
import * as szCatalog from '@serve.zone/catalog';

// TypedSocket for real-time push communication
import * as typedsocket from '@api.global/typedsocket';

// QR code generation for WireGuard configs
import * as qrcode from 'qrcode';

export {
  deesElement,
  deesCatalog,
  szCatalog,
  typedsocket,
  qrcode,
}

// domtools gives us TypedRequest and other utilities
export const domtools = deesElement.domtools;
